__turbopack_context__.v({
  "actions": "EjpO1W_actions",
  "count": "EjpO1W_count",
  "error": "EjpO1W_error",
  "fewLeft": "EjpO1W_fewLeft",
  "field": "EjpO1W_field",
  "icon": "EjpO1W_icon",
  "inStock": "EjpO1W_inStock",
  "info": "EjpO1W_info",
  "infoActions": "EjpO1W_infoActions",
  "infoBody": "EjpO1W_infoBody",
  "infoText": "EjpO1W_infoText",
  "input": "EjpO1W_input",
  "link": "EjpO1W_link",
  "message": "EjpO1W_message",
  "muted": "EjpO1W_muted",
  "note": "EjpO1W_note",
  "option": "EjpO1W_option",
  "optionActive": "EjpO1W_optionActive",
  "optionDisabled": "EjpO1W_optionDisabled",
  "optionHint": "EjpO1W_optionHint",
  "optionLabel": "EjpO1W_optionLabel",
  "optionTop": "EjpO1W_optionTop",
  "options": "EjpO1W_options",
  "panel": "EjpO1W_panel",
  "price": "EjpO1W_price",
  "root": "EjpO1W_root",
  "showAll": "EjpO1W_showAll",
  "store": "EjpO1W_store",
  "storeActive": "EjpO1W_storeActive",
  "storeDisabled": "EjpO1W_storeDisabled",
  "storeMain": "EjpO1W_storeMain",
  "storeMeta": "EjpO1W_storeMeta",
  "storeName": "EjpO1W_storeName",
  "storeWhen": "EjpO1W_storeWhen",
  "stores": "EjpO1W_stores",
  "title": "EjpO1W_title",
  "visuallyHidden": "EjpO1W_visuallyHidden",
  "whenDate": "EjpO1W_whenDate",
  "whenLabel": "EjpO1W_whenLabel",
  "zip": "EjpO1W_zip",
  "zipLabel": "EjpO1W_zipLabel",
});
